// src/data/workVisas.js
// Edit everything about the work visas HERE (cards + detail pages use this file)

export const confirmedSteps = [
  { title: ' Profile Check', text: 'We review your CV, education and experience to confirm you are eligible.' },
  { title: 'Job Offer / Contract', text: 'You get a valid employer job offer or work contract.' },
  { title: 'Documents & Application', text: 'We prepare your documents and submit the work permit / visa application.' },
  { title: 'Visa Approval (Confirmed Visa)', text: 'Once approved, the visa is stamped or issued to you.' },
  { title: 'Travel & Residence Card', text: 'You travel, start work and receive your residence card in the country.' },
];

export const workVisas = [
  {
    slug: 'france',
    country: 'France',
    flag: '🇫🇷',
    capital: 'Paris',
    image: 'https://images.unsplash.com/photo-1431274172761-fca41d930114?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    tagline: 'Work in the heart of Europe',
    latestVisa: {
      name: 'Salaried Worker Visa',
      desc: 'For people with a work contract from a French employer. The employer starts the work authorization process.',
    },
    popularVisa: {
      name: 'Talent Passport',
      desc: 'Popular multi-year permit for skilled professionals and EU Blue Card type profiles.',
    },
    processing: '6–12 weeks (approx.)',
    permitValidity: '1 to 4 years, renewable',
    prAfter: 'Usually around 3 years of legal residence',
    requirements: ['Valid passport', 'Job contract from French employer', 'Qualification / experience proof', 'Clean police record', 'Health insurance'],
    benefits: ['Work legally in France', 'Family can join you', 'Travel inside the Schengen area', 'Path to long-term residence'],
    confirmedNote: 'Your visa is confirmed after the employer’s work authorization is approved and the consulate issues the visa.',
  },
  {
    slug: 'belgium',
    country: 'Belgium',
    flag: '🇧🇪',
    capital: 'Brussels',
    image: 'https://images.unsplash.com/photo-1569878165730-a4d34917f3d2?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    tagline: 'Jobs in the center of the EU',
    latestVisa: {
      name: 'Single Permit (Work + Residence)',
      desc: 'One combined permit that allows you to live and work in Belgium for a specific employer.',
    },
    popularVisa: {
      name: 'Highly Qualified Worker / EU Blue Card',
      desc: 'For degree holders and skilled professionals with a qualifying job offer.',
    },
    processing: '8–14 weeks (approx.)',
    permitValidity: '1 to 3 years, renewable',
    prAfter: 'Usually around 3 years of legal residence',
    requirements: ['Valid passport', 'Employment contract', 'Degree / experience proof', 'Clean police record', 'Medical certificate'],
    benefits: ['Live and work in Belgium', 'Multilingual job market', 'Family reunification', 'Path to long-term residence'],
    confirmedNote: 'Your visa is confirmed once the regional authority approves the single permit and the embassy issues the visa.',
  },
  {
    slug: 'greece',
    country: 'Greece',
    flag: '🇬🇷',
    capital: 'Athens',
    image: 'https://images.unsplash.com/photo-1580502304784-8985b7eb7260?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    tagline: 'Work and live in the Mediterranean',
    latestVisa: {
      name: 'National Visa (Type D) – Employment',
      desc: 'Work visa for people hired by a Greek employer in a salaried role.',
    },
    popularVisa: {
      name: 'EU Blue Card',
      desc: 'For highly skilled workers with a higher education degree and a qualifying job offer.',
    },
    processing: '8–16 weeks (approx.)',
    permitValidity: '1 to 3 years, renewable',
    prAfter: 'Usually around 3 years of legal residence',
    requirements: ['Valid passport', 'Job contract / approval from employer', 'Qualification proof', 'Clean police record', 'Health insurance'],
    benefits: ['Work legally in Greece', 'Great lifestyle and climate', 'Family can join you', 'Path to long-term residence'],
    confirmedNote: 'Your visa is confirmed after the work approval is granted in Greece and the consulate stamps your visa.',
  },
  {
    slug: 'bulgaria',
    country: 'Bulgaria',
    flag: '🇧🇬',
    capital: 'Sofia',
    image: 'https://images.unsplash.com/photo-1633210181101-774c588bc997?q=80&w=1277&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    tagline: 'Affordable living, growing job market',
    latestVisa: {
      name: 'Type D Work Visa',
      desc: 'Long-stay visa for people with a work permit and job offer from a Bulgarian employer.',
    },
    popularVisa: {
      name: 'EU Blue Card',
      desc: 'For skilled professionals with higher education and a qualifying salary offer.',
    },
    processing: '6–12 weeks (approx.)',
    permitValidity: '1 to 3 years, renewable',
    prAfter: 'Usually around 3 years of legal residence',
    requirements: ['Valid passport', 'Employer work permit / contract', 'Education & experience proof', 'Clean police record', 'Health insurance'],
    benefits: ['Low cost of living', 'EU country with growing IT & service jobs', 'Family can join you', 'Path to long-term residence'],
    confirmedNote: 'Your visa is confirmed after the work permit is approved and the embassy issues the Type D visa.',
  },
  {
    slug: 'spain',
    country: 'Spain',
    flag: '🇪🇸',
    capital: 'Madrid',
    image: 'https://images.unsplash.com/photo-1539037116277-4db20889f2d4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    tagline: 'Work in one of Europe’s top destinations',
    latestVisa: {
      name: 'Work & Residence Permit (Employee)',
      desc: 'Permit for foreign workers with a job offer from a Spanish employer.',
    },
    popularVisa: {
      name: 'Highly Qualified Professional Permit',
      desc: 'Fast-track style permit for skilled workers and managers with qualifying job offers.',
    },
    processing: '8–16 weeks (approx.)',
    permitValidity: '1 to 3 years, renewable',
    prAfter: 'Usually around 3 years of legal residence',
    requirements: ['Valid passport', 'Job offer / contract', 'Degree or experience proof', 'Clean police record', 'Medical certificate'],
    benefits: ['Work legally in Spain', 'Large job market', 'Family reunification', 'Path to long-term residence'],
    confirmedNote: 'Your visa is confirmed after the work and residence authorization is approved and the consulate issues the visa.',
  },
  {
    slug: 'portugal',
    country: 'Portugal',
    flag: '🇵🇹',
    capital: 'Lisbon',
    image: 'https://images.unsplash.com/photo-1555881400-74d7acaacd8b?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    tagline: 'Popular choice for skilled workers',
    latestVisa: {
      name: 'Work Visa (Employed Activity)',
      desc: 'Residence visa for people with a work contract or promise of work from a Portuguese employer.',
    },
    popularVisa: {
      name: 'Job Seeker Visa',
      desc: 'Allows qualified people to enter Portugal and look for a job, then convert to a work residence permit.',
    },
    processing: '8–16 weeks (approx.)',
    permitValidity: '1 to 2 years, renewable',
    prAfter: 'Usually around 3 years of legal residence',
    requirements: ['Valid passport', 'Work contract / job offer', 'Qualification proof', 'Clean police record', 'Health insurance'],
    benefits: ['Work legally in Portugal', 'Friendly, English-speaking work culture', 'Family can join you', 'Path to long-term residence'],
    confirmedNote: 'Your visa is confirmed after the consulate approves your residence visa; you then complete your residence permit in Portugal.',
  },
];